var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "concept-taxes" },
    [
      _c("div", { staticClass: "detail-title-container is-flex" }, [
        _c("h5", { staticClass: "title is-5" }, [
          _vm._v("\n      Impuestos\n    ")
        ]),
        !_vm.disabled
          ? _c(
              "div",
              { staticClass: "is-centered" },
              [
                _c(
                  "BField",
                  { staticClass: "new-tax" },
                  [
                    _c(
                      "BSelect",
                      {
                        attrs: { placeholder: "Tipo" },
                        model: {
                          value: _vm.newTaxType,
                          callback: function($$v) {
                            _vm.newTaxType = $$v
                          },
                          expression: "newTaxType"
                        }
                      },
                      [
                        _c("option", { attrs: { value: "retained" } }, [
                          _vm._v("\n            Retención\n          ")
                        ]),
                        _c("option", { attrs: { value: "transfer" } }, [
                          _vm._v("\n            Traslado\n          ")
                        ]),
                        _c("option", { attrs: { value: "localTransfer" } }, [
                          _vm._v("\n            Traslado Local\n          ")
                        ]),
                        _c("option", { attrs: { value: "localWithHold" } }, [
                          _vm._v(
                            "\n            Retenciones Locales\n          "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "BField",
                  { staticClass: "new-tax" },
                  [
                    _c(
                      "BSelect",
                      {
                        attrs: { placeholder: "Impuesto" },
                        model: {
                          value: _vm.newTaxTax,
                          callback: function($$v) {
                            _vm.newTaxTax = $$v
                          },
                          expression: "newTaxTax"
                        }
                      },
                      [
                        _vm.newTaxType === "retained"
                          ? _c("option", { attrs: { value: "001" } }, [
                              _vm._v("\n            ISR\n          ")
                            ])
                          : _vm._e(),
                        ["transfer", "retained"].includes(_vm.newTaxType)
                          ? _c("option", { attrs: { value: "002" } }, [
                              _vm._v("\n            IVA\n          ")
                            ])
                          : _vm._e(),
                        _vm.newTaxType === "transfer"
                          ? _c("option", { attrs: { value: "003" } }, [
                              _vm._v("\n            IEPS\n          ")
                            ])
                          : _vm._e(),
                        _vm.newTaxType === "localTransfer"
                          ? _c("option", { attrs: { value: "ISH" } }, [
                              _vm._v("\n            ISH\n          ")
                            ])
                          : _vm._e(),
                        _vm.newTaxType === "localWithHold"
                          ? _c("option", { attrs: { value: "millar" } }, [
                              _vm._v("\n            N al millar\n          ")
                            ])
                          : _vm._e(),
                        _vm.newTaxType === "localWithHold"
                          ? _c("option", { attrs: { value: "cedular" } }, [
                              _vm._v("\n            Cedular\n          ")
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "BField",
                  { staticClass: "new-tax" },
                  [
                    _c(
                      "BSelect",
                      {
                        attrs: { placeholder: "Tasa/Cuota" },
                        model: {
                          value: _vm.newTaxFactorType,
                          callback: function($$v) {
                            _vm.newTaxFactorType = $$v
                          },
                          expression: "newTaxFactorType"
                        }
                      },
                      [
                        _c("option", { attrs: { value: "Tasa" } }, [
                          _vm._v("\n            Tasa\n          ")
                        ]),
                        _vm.newTaxTax === "003"
                          ? _c("option", { attrs: { value: "Cuota" } }, [
                              _vm._v("\n            Cuota\n          ")
                            ])
                          : _vm._e(),
                        ["002", "003"].includes(_vm.newTaxTax) &&
                        _vm.newTaxType !== "retained"
                          ? _c("option", { attrs: { value: "Exento" } }, [
                              _vm._v("\n            Exento\n          ")
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm.newTaxTax === "001" && _vm.newTaxType === "retained"
                  ? _c(
                      "BField",
                      {
                        staticClass: "new-tax fee",
                        attrs: { message: "0.00 - 0.35" }
                      },
                      [
                        _c("BInput", {
                          ref: "inputNumber",
                          attrs: {
                            type: "number",
                            placeholder: "0.00",
                            step: "0.000001",
                            min: "0.00",
                            max: "0.35",
                            expanded: ""
                          },
                          model: {
                            value: _vm.newTaxFee,
                            callback: function($$v) {
                              _vm.newTaxFee = $$v
                            },
                            expression: "newTaxFee"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.newTaxTax === "003" && _vm.newTaxFactorType === "Cuota"
                  ? _c(
                      "BField",
                      {
                        staticClass: "new-tax fee",
                        attrs: { message: "0.00 - 43.77" }
                      },
                      [
                        _c("BInput", {
                          ref: "inputNumber",
                          attrs: {
                            type: "number",
                            step: "0.000001",
                            placeholder: "0.00",
                            min: "0.00",
                            max: "43.77",
                            expanded: ""
                          },
                          model: {
                            value: _vm.newTaxFee,
                            callback: function($$v) {
                              _vm.newTaxFee = $$v
                            },
                            expression: "newTaxFee"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.newTaxTax === "002" &&
                    _vm.newTaxType === "retained" &&
                    _vm.newTaxFactorType !== "Exento"
                  ? _c(
                      "BField",
                      {
                        staticClass: "new-tax fee",
                        attrs: { message: "0.00 - 0.16" }
                      },
                      [
                        _c("BInput", {
                          ref: "inputNumber",
                          attrs: {
                            type: "number",
                            step: "0.000001",
                            min: "0.00",
                            max: "0.16",
                            placeholder: "0.00",
                            expanded: ""
                          },
                          model: {
                            value: _vm.newTaxFee,
                            callback: function($$v) {
                              _vm.newTaxFee = $$v
                            },
                            expression: "newTaxFee"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.newTaxTax === "ISH" &&
                    _vm.newTaxType === "localTransfer"
                  ? _c(
                      "BField",
                      {
                        staticClass: "new-tax fee",
                        attrs: { message: "0.02 - 0.05" }
                      },
                      [
                        _c("BInput", {
                          ref: "inputNumber",
                          attrs: {
                            type: "number",
                            step: "0.000001",
                            min: "0.02",
                            max: "0.05",
                            placeholder: "0.00",
                            expanded: ""
                          },
                          model: {
                            value: _vm.newTaxFee,
                            callback: function($$v) {
                              _vm.newTaxFee = $$v
                            },
                            expression: "newTaxFee"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.newTaxTax === "millar" &&
                    _vm.newTaxType === "localWithHold"
                  ? _c(
                      "BField",
                      {
                        staticClass: "new-tax fee",
                        attrs: { message: "0.02 | 0.05" }
                      },
                      [
                        _c(
                          "BSelect",
                          {
                            attrs: { placeholder: "Valor" },
                            model: {
                              value: _vm.newTaxFee,
                              callback: function($$v) {
                                _vm.newTaxFee = $$v
                              },
                              expression: "newTaxFee"
                            }
                          },
                          [
                            _c("option", { attrs: { value: "0.05" } }, [
                              _vm._v("\n            5 al millar\n          ")
                            ]),
                            _c("option", { attrs: { value: "0.02" } }, [
                              _vm._v("\n            2 al millar\n          ")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm.newTaxTax === "cedular" &&
                    _vm.newTaxType === "localWithHold"
                  ? _c(
                      "BField",
                      {
                        staticClass: "new-tax fee",
                        attrs: { message: "0.02 - 0.05" }
                      },
                      [
                        _c("BInput", {
                          ref: "inputNumber",
                          attrs: {
                            type: "number",
                            placeholder: "0.00",
                            step: "0.000001",
                            min: "0.02",
                            max: "0.05",
                            expanded: ""
                          },
                          model: {
                            value: _vm.newTaxFee,
                            callback: function($$v) {
                              _vm.newTaxFee = $$v
                            },
                            expression: "newTaxFee"
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "BField",
                      { staticClass: "new-tax" },
                      [
                        _c(
                          "BSelect",
                          {
                            attrs: { placeholder: "Valor" },
                            model: {
                              value: _vm.newTaxFee,
                              callback: function($$v) {
                                _vm.newTaxFee = $$v
                              },
                              expression: "newTaxFee"
                            }
                          },
                          [
                            _vm.newTaxTax === "002" &&
                            _vm.newTaxType === "transfer" &&
                            _vm.newTaxFactorType !== "Exento"
                              ? _c("option", { attrs: { value: "0.000000" } }, [
                                  _vm._v("\n            0.00\n          ")
                                ])
                              : _vm._e(),
                            _vm.newTaxTax === "002" &&
                            _vm.newTaxType === "transfer" &&
                            _vm.newTaxFactorType !== "Exento"
                              ? _c("option", { attrs: { value: "0.080000" } }, [
                                  _vm._v("\n            0.08\n          ")
                                ])
                              : _vm._e(),
                            _vm.newTaxTax === "002" &&
                            _vm.newTaxType === "transfer" &&
                            _vm.newTaxFactorType !== "Exento"
                              ? _c("option", { attrs: { value: "0.160000" } }, [
                                  _vm._v("\n            0.16\n          ")
                                ])
                              : _vm._e(),
                            ["002", "003"].includes(_vm.newTaxTax) &&
                            (_vm.newTaxType === "transfer" ||
                              _vm.newTaxType === "retained") &&
                            _vm.newTaxFactorType === "Exento"
                              ? _c("option", { attrs: { value: "Exento" } }, [
                                  _vm._v("\n            Exento\n          ")
                                ])
                              : _vm._e(),
                            _vm.newTaxTax === "003" &&
                            _vm.newTaxFactorType === "Tasa"
                              ? _vm._l(_vm.iepsFee, function(option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option.value,
                                      domProps: { value: option.value }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(option.label) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    ),
                !_vm.disabled
                  ? _c(
                      "a",
                      {
                        staticClass: "button add-concept is-success is-rounded",
                        on: { click: _vm.addTax }
                      },
                      [
                        _c("BIcon", { attrs: { icon: "plus" } }),
                        _c("span", [
                          _vm._v("\n          Agregar Impuesto\n        ")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _c("BTable", {
        attrs: { data: _vm.taxesDetail },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(taxProps) {
              return [
                _c(
                  "BTableColumn",
                  { attrs: { field: "type", label: "Tipo", centered: "" } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.taxTypeLabel(taxProps.row.type)) +
                        "\n      "
                    )
                  ]
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "tax", label: "Impuesto", centered: "" } },
                  [
                    taxProps.row.tax === "001"
                      ? _c("span", [_vm._v("\n          ISR\n        ")])
                      : _vm._e(),
                    taxProps.row.tax === "002"
                      ? _c("span", [_vm._v("\n          IVA\n        ")])
                      : _vm._e(),
                    taxProps.row.tax === "003"
                      ? _c("span", [_vm._v("\n          IEPS\n        ")])
                      : _vm._e(),
                    taxProps.row.tax === "ISH"
                      ? _c("span", [_vm._v("\n          ISH\n        ")])
                      : _vm._e(),
                    taxProps.row.tax === "millar"
                      ? _c("span", [
                          _vm._v("\n          N al millar\n        ")
                        ])
                      : _vm._e(),
                    taxProps.row.tax === "cedular"
                      ? _c("span", [_vm._v("\n          Cedular\n        ")])
                      : _vm._e()
                  ]
                ),
                _c(
                  "BTableColumn",
                  {
                    attrs: {
                      field: "factorType",
                      label: "Tasa o Cuota",
                      centered: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(taxProps.row.factorType) +
                        "\n      "
                    )
                  ]
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "fee", label: "Valor", centered: "" } },
                  [_vm._v("\n        " + _vm._s(taxProps.row.fee) + "\n      ")]
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "amount", label: "Monto", centered: "" } },
                  [
                    _vm._v(
                      "\n        " + _vm._s(taxProps.row.amount) + "\n      "
                    )
                  ]
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "actions", label: "", centered: "" } },
                  [
                    _vm.taxesDetail.length > 1 && !_vm.disabled
                      ? _c(
                          "a",
                          {
                            staticClass: "button is-danger",
                            on: {
                              click: function($event) {
                                return _vm.deleteTax(
                                  taxProps.row.type,
                                  taxProps.row.tax,
                                  taxProps.row.fee
                                )
                              }
                            }
                          },
                          [
                            _c("BIcon", {
                              attrs: { icon: "delete", "aria-hidden": "true" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }